var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 370.1 331.3",
    style: {
      enableBackground: "new 0 0 370.1 331.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st6{fill:#282828}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1981.964,
    y1: 2444.496,
    x2: 2163.297,
    y2: 2444.496,
    gradientTransform: "rotate(107.241 1998.703 589.98)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    style: {
      stopColor: "#2cf4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2cb2e1"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 197,
    cy: 139.1,
    r: 90.7,
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.602,
    y1: 113.132,
    x2: 324.336,
    y2: 222.118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    style: {
      stopColor: "#2cf4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2cb2e1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.7 111.9c6.5 8.8 9.9 19.2 9.9 30 0 13.1-5.4 25.2-14.6 35l5.6 20.9h17l17.9-20.3 4.8-29.7 1-17.7-17.7-20-23.9 1.8z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 111.456,
    y1: 126.742,
    x2: 224.122,
    y2: 280.742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2ce5e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2cb2e1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m63.7 200.2 3.1 12.3s36.6 75.1 119 103c0 0 77.2-32 110.5-86.3l-48.2-40.1s-22 17.5-54.7 17.5-77.1-19.5-77.1-59.7 46-54.9 46-54.9l-19.6-4.8H92.6l-31.8 76.6 2.9 36.4z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.474,
    y1: 233.727,
    x2: 186.474,
    y2: 36.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0d0d0d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.6 119.5c-1.4-1.4-42-44.4-153.3-82.7l-.7-.3c-107.8 37-154.2 83-154.2 83 4.2 24.5 14.8 51.8 24.4 73 .8 1.8 13.6 24.4 23.1 36.7-5.6-12.3-11.7-23-11.7-41.4 0-51.9 40.2-94.1 90.5-95.9 1.2 0 2.5 0 3.7.1l-12-12s48.3-8.1 110.3 29.4c0 0 .9 1.9 0 7.5 0 0 29.2 12.6 31.7 37.1s-13 38.5-25.5 40.5c0 0 6.5-10.1-3.5-15.5-2.1-1.2-4.6-1.7-7.1-1.6-19.1 0-21.3 21.8-21.3 21.8-.2 1.1-.2 2.2-.2 3.3 0 0-3.2 31.9 53.6 31.3 0 0 28.8-32.6 36.4-61.9 2.8-10.8 4.8-18.9 6.1-24.9 3.2-8.5 6.3-17.3 9.3-26.4l.4-1.1z",
    style: {
      fill: "url(#SVGID_4_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236 119.1c.8-.4 3.4-1.7 6.4-4.8 6 .8 11.9 2.7 11.9 2.7-10.9-6.6-25.8-10.5-42.3-10.4 0 0 6.3 9 23.8 12.7l.2-.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M186.1 41.3c10.6 3.3 87.6 28.9 149.2 79.8l6.9-2-.5-.4c-60.2-51-136.3-77.5-152.1-82.6l-1.5-.5-2-.6-3.5 1.1c-15.8 5.1-91.9 31.6-152.1 82.6l-.7.6 6.7 2.2c61.6-51.2 139-76.9 149.6-80.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.057,
    y1: 248.796,
    x2: 186.057,
    y2: -16.973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    style: {
      stopColor: "#2cf4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2cb2e1"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.841,
    y1: 168.862,
    x2: 347.273,
    y2: 168.862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    style: {
      stopColor: "#2cf4e1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2cb2e1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.7 109.2c-60.2-51-136.3-77.5-152.1-82.6l-1.5-.5-2-.6-3.5 1.1c-15.8 5.1-91.9 31.6-152.1 82.6l-1.3 1.1.3 1.7c.1.4 6.6 39.1 28.8 82.8 13.1 25.7 29 48 47.2 66.5 22.3 22.6 48.3 39.3 77.2 49.7l1.7.6 1.7.6 1.8-.7 1.7-.6c28.9-10.4 54.8-27.1 77.2-49.7 18.2-18.4 34.1-40.8 47.2-66.5 22.2-43.6 28.8-82.4 28.8-82.8l.3-1.7-1.4-1zM308.5 192c-12.8 25.1-28.3 47-46.1 65-22.1 22.3-47.7 38.7-76.3 48.8-28.6-10.1-54.2-26.4-76.3-48.7-17.8-18-33.3-39.8-46.1-64.9-19.3-37.8-26.5-71.7-28-79.5C97.4 61 175.4 35.2 186.1 31.8c10.6 3.4 88.7 29.2 150.4 80.9-1.5 7.7-8.8 41.6-28 79.3z",
    style: {
      fill: "url(#SVGID_5_)",
      stroke: "url(#SVGID_6_)",
      strokeWidth: 8,
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnt);
export default __webpack_public_path__ + "static/media/ant.990fdec576dfd312ad03578a71e119de.svg";
export { ForwardRef as ReactComponent };